import { store } from '@/store/'
import Vue from 'vue'
import { setXVtableMutations } from '../../XVtableV2'
import axios from 'axios'
import { util } from 'pevueglobal'
import locStore from 'store2'

const state = {
  filterdata: {
    courseTree: [],
    courseTypes: [],
  },
  competences: [],
  categories: [],
  filterCourseOtherProfGroup: null,
  clusters: [],
  languages: [],
  pageInfo: {
    hasNextPage: false,
  },
  totalCount: 0,
  filterinputdata: {
    cbSubSubCourseTree: 0,
    cbSubSubCourseTreeDropdown: '',
    tbxStartDate: null,
    selectedCompetence: '',
    selectedCategory: '',
    tbxCourseNameId: '',
    tbxInstitute: '',
    categoryPoints: 0,
    cbInstellingsAccr: false,
    tbxLocatie: '',
    locatieRange: 0,
    cbCourseType: 1,
    cbclusters: [],
    selectedLanguage: '',
    selectedCourseRating: 0,
    selectedEducationRating: 0,
    filterLocationLong: 0,
    filterLocationLat: 0,
    filterLocation: false,
    selectedCompetencePercentage: 0,
  },
  filtersettings: {
    locationmarks: [],
    showCourseTreeHeader: false,
    courseTreeDropdown: false,
    courseTreeSubSubItems: [],
    courseTreeHeader: '',
    starRating: [],
    maxPoints: 0,
    maxPointsMarks: [],
    hasAccreditation: false,
    hasRatings: false,
  },
  profgroupName: '',
  lblMaatwerkBeschrijving: '',
  hideCoursePoints: false,
  profgroupid: 0,
  filterLoaded: false,
  filterSettingsLoaded: false,
  hasFilter: false,
  tableSkip: 0,
  loadingNewItems: false,
  loadMobileFilter: false,
  stickyHeight: 0,
  activeProfGr: '',
  activeProfOrgId: '',
  tableLoader: true,
  agendaTable: {
    tablesetting: {},
    tablecolumnsetting: [],
    tabledata: [],
    rowvisible: [],
  },
}

// getters
const getters = {
  agendaTable: (state) => state.agendaTable,
  filterdata: (state) => state.filterdata,
  filtersettings: (state) => state.filtersettings,
  filterLoaded: (state) => state.filterLoaded,
  filterSettingsLoaded: (state) => state.filterSettingsLoaded,
  totalCount: (state) => state.totalCount,
  profgroupid: (state) => state.profgroupid,
  loadMobileFilter: (state) => state.loadMobileFilter,
  profgroupName: (state) => state.profgroupName,
  lblMaatwerkBeschrijving: (state) => state.lblMaatwerkBeschrijving,
  hideCoursePoints: (state) => state.hideCoursePoints,
  filterinputdata: (state) => state.filterinputdata,
  stickyHeight: (state) => state.stickyHeight,
  activeProfGr: (state) => state.activeProfGr,
  activeProfOrgId: (state) => state.activeProfOrgId,
  tableLoader: (state) => state.tableLoader,
  hideClusterChoice: (state) => state.filterCourseOtherProfGroup === 1,
  competences: (state) => {
    let dlCompetences = state.competences.map((comp) => ({
      value: comp.id,
      labelText: comp.name,
    }))
    return dlCompetences
  },
  categories: (state) => {
    let dlCategories = state.categories.map((cat) => ({
      value: cat.id,
      labelText: cat.name,
    }))
    return dlCategories.sort(dynamicSort('labelText'))
  },
  clusters: (state) => {
    let dlClusters = state.clusters.map((c) => ({
      value: c.id,
      labelText: c.abbreviation,
    }))
    return dlClusters
  },
  languages: (state) => {
    let dlLanguages = state.languages.map((c) => ({
      value: c.id,
      labelText: c.name,
    }))
    return dlLanguages
  },
}

// actions
const actions = {
  getTexten: async ({ dispatch }) => {
    let textIDs = [
      56, 93, 95, 812, 1338, 14642, 3294, 3346, 4397, 5136, 6875, 8444, 10631, 10632, 13459, 16728, 16729, 16730, 16746,
      16817, 16943, 18162, 18908,
    ]
    for (var i = 16702; i <= 16721; i++) {
      textIDs.push(i)
    }
    for (var j = 16763; j <= 16767; j++) {
      textIDs.push(j)
    }
    for (var k = 18921; k <= 18927; k++) {
      textIDs.push(k)
    }
    await dispatch('gettranslations', textIDs, { root: true })
  },
  getActiveProfGr: async ({ commit }) => {
    commit('setActiveProfGr')
  },
  getActiveProfOrgid: async ({ commit }) => {
    commit('setActiveProfOrgid')
  },
  getChangeLanguage: async ({ commit, dispatch }, langId) => {
    if (!util.UgetCookie('urlparamLanguageId') || util.UgetCookie('urlparamLanguageId') !== langId) {
      commit('setLanguageCookie', langId)
      dispatch('changeLang', Number(langId), { root: true })
    }
  },
  getFilterValuesFromLocalStorage: async ({ commit, dispatch }) => {
    commit('setStateFilterInputDataFromLocalStorage')
    dispatch('filterTableData')
  },
  getFilters: async ({ commit, dispatch }) => {
    const query = `query GetCourseCatalogFilters($professionGroupId: Int!, $date: DateTime, $language: String) {
      educationInstitutesLookup(professionGroupId: $professionGroupId, date: $date, language: $language, )
      {
        id
        name
      }
      categoriesLookup(professionGroupId: $professionGroupId, date: $date, language: $language)
      {
        id
        name
      }
      competencesLookup(professionGroupId: $professionGroupId, date: $date, language: $language)
      {
        id
        sequenceNumber
        name
      }
      courseTrees(professionGroupId: $professionGroupId, language: $language)
      {
        id
        name
        description
        subLevels  {
          id
          name
          description
          subSubLevels {
            id
            name
            description
          }
        }
      }
      languageSetsLookup(professionGroupId: $professionGroupId, language: $language)
      {
        id
        name
      }
    }`
    const client = await util.createUrqlClient('/public/graphql/')
    const opties = {
      professionGroupId: state.profgroupid,
      date: new Date(),
      language: util.GetCulture().split('-')[0],
    }
    client
      .query(query, opties)
      .toPromise()
      .then((data) => {
        if (data.error === undefined) {
          commit('setFilterData', data.data)
          if (data.data.courseTrees.length > 0) {
            commit('setFilterCourseTrees', data.data.courseTrees)
          }
        } else if (data.error.graphQLErrors[0].extensions.message === 'User not authenticated.') {
          commit('setRedirectCatMelding')
        }
      })
  },
  getFilterSettings: async ({ commit, dispatch }) => {
    const query = `query CourseCatalogueInternalQuery(
      $professionGroupId: Int!
      $date: DateTime!
      $language: String!
    ) {
      courseCatalogueSettings(professionGroupId: $professionGroupId, date: $date, language: $language) {
        hasAccreditation
        hasRatings
        hideCoursePoints
        maximumPoints
        profGroupName
        profgrouplevelheaderName
        profgroupcoursecatalogueName
        filterCourseOtherProfGroup
      }
      courseTypes(professionGroupId: $professionGroupId, language: $language) {
        id
        name
      }
      clustersLookup(professionGroupId: $professionGroupId, language: $language) {
        id
        name
        abbreviation
      }
    }`
    const client = await util.createUrqlClient('/internal/graphql/')
    const opties = {
      professionGroupId: state.profgroupid,
      date: new Date(),
      language: util.GetCulture().split('-')[0],
      where: null,
    }
    client
      .query(query, opties)
      .toPromise()
      .then((data) => {
        if (data.error === undefined) {
          commit('setFilterSettings', data.data)
          if (data.data.clustersLookup.length !== 0) {
            dispatch('getCoursetrees', data.data.clustersLookup)
          }
        } else if (data.error.graphQLErrors[0].extensions.message === 'User not authenticated.') {
          commit('setRedirectCatMelding')
        }
      })
  },
  getCoursetrees: async ({ commit, dispatch }, externalCoursetrees) => {
    const queryCourseTree = `query GetCourseCatalogFilters(
      $professionGroupId: Int!, $language: String) {
        courseTrees(professionGroupId: $professionGroupId, language: $language)
        {
          id
          name
          description
          subLevels  {
            id
            name
            description
            subSubLevels {
              id
              name
              description
            }
          }
        }  
      }`
    const queryCourseTreeHeaderName = `query CourseCatalogueInternalQuery(
      $professionGroupId: Int!
      $date: DateTime!
      $language: String!
      ) {
          courseCatalogueSettings(professionGroupId: $professionGroupId, date: $date, language: $language) {
            profgrouplevelheaderName
        }
      }`

    const publicClient = await util.createUrqlClient('/public/graphql/')
    const internalClient = await util.createUrqlClient('/internal/graphql/')
    
    externalCoursetrees.forEach((c) => {
      const opties = {
        professionGroupId: c.id,
        date: new Date(),
        language: util.GetCulture().split('-')[0],
      }

      publicClient
        .query(queryCourseTree, opties)
        .toPromise()
        .then((data) => {
          if (data && data.data && data.data.courseTrees && data.data.courseTrees.length > 0) {
            commit('setFilterCourseTrees', data.data.courseTrees)
          }
        })
        
      internalClient
        .query(queryCourseTreeHeaderName, opties)
        .toPromise()
        .then((dataHeaderName) => {
          if (dataHeaderName && dataHeaderName.data && dataHeaderName.data.courseCatalogueSettings &&
              dataHeaderName.data.courseCatalogueSettings.length > 0) {
            commit('setCourseTreeHeaderName', dataHeaderName.data.courseCatalogueSettings[0].profgrouplevelheaderName)
          }
        })
    })
  },
  getTableData: async ({ commit, dispatch }) => {
    commit('setStateFilterInputDataFromLocalStorage')
    commit('setTableLoading', true)
    if (!state.hasFilter) {
      const query = `query courseCatalogue(
        $profgroupid: Int!, $language: String!, $date: DateTime, $skip: Int!, $take: Int!
        $whereWith: CourseCatalogueItemWithDateFilterInput,
        $whereWithout: CourseCatalogueItemWithoutDateFilterInput
      )
      {
        courseCatalogueItemsWithDate(professionGroupId: $profgroupid, language: $language, dateFrom: $date, skip: $skip, take: $take, 
        where: $whereWith,
        order: {
          startDate: ASC,
          name: ASC
        }
        )
        
        {
          totalCount
          pageInfo{
            hasNextPage
          }
          items{
            editionId
            allowProfToAdd
            isRemoteAttendance
            agendaSubject {
              id
            }
            startDate
            name
            locationCity
            courseStatus
            
            locationCountry {
              code
            }
            course {
              id
              educationInstitute {
                name
              }
              rating {
                courseRatingAverage
                courseRatingCount
                educationRatingAverage
                educationRatingCount
              }
            }
            extraColumn
          }
        }
        courseCatalogueItemsWithoutDate(professionGroupId: $profgroupid, language: $language, date: $date, skip: $skip, take: $take, 
        where: $whereWithout,
        order: {
          name: ASC
        }
        ) {
          totalCount
          pageInfo {
            hasNextPage
          }
          items {
            allowProfToAdd
            name
            courseStatus
            course {
              languageSets {
                id
              }
              rating {
                courseRatingAverage
                courseRatingCount
                educationRatingAverage
                educationRatingCount
              }
              id
              courseType
              educationInstitute {
                name
              }
            }
            extraColumn
          }
        }
      }`
      const client = await util.createUrqlClient('/public/graphql/')
      let where = { and: [] }
      if (state.filterinputdata.cbCourseType === 1) {
        state.hasFilter = true
        where.and.push({
          course: {
            and: [
              {
                courseType: { neq: 2 },
              },
              { courseType: { neq: 3 } },
            ],
          },
        })
      } else if (state.filterinputdata.cbCourseType === 2 || state.filterinputdata.cbCourseType === 3) {
        state.hasFilter = true
        where.and.push({
          course: {
            courseType: { eq: state.filterinputdata.cbCourseType },
          },
        })
      }

      let clustersToFilter = {}
      let clustersToFilterArr = []
      state.clusters.map((cluster) => {
        if (state.filterinputdata.cbclusters.indexOf(cluster.id)) {
          clustersToFilterArr.push({
            // PE-29999 Agenda cluster filter werkt niet icm > 2 clusters
            // Sander 30-08-2023: changed neq into eq
            requestedByClusterId: {
              eq: cluster.id,
            },
          })
        }
      })
      clustersToFilter = {
        // PE-29999 Agenda cluster filter werkt niet icm > 2 clusters
        // Sander 30-08-2023: changed and into or
        course: {
          or: clustersToFilterArr,
        },
      }

      if (clustersToFilterArr.length > 0) {
        where.and.push(clustersToFilter)
      }
      const opties = {
        profgroupid: state.profgroupid,
        language: util.GetCulture().split('-')[0],
        date: new Date(),
        skip: state.tableSkip,
        take: 49,
        whereWith: where,
        whereWithout: where,
      }
      client
        .query(query, opties)
        .toPromise()
        .then((data) => {
          if (data.error === undefined) {
            let totalCountWithDate =
              data.data.courseCatalogueItemsWithDate.totalCount !== null
                ? data.data.courseCatalogueItemsWithDate.totalCount
                : 0
            let pageInfoWithDate = data.data.courseCatalogueItemsWithDate.pageInfo
            let items1 = data.data.courseCatalogueItemsWithDate.items.map((d) => {
              var {
                startDate,
                name,
                locationCity,
                course,
                locationCountry,
                isRemoteAttendance,
                agendaSubject,
                courseStatus,
                extraColumn,
                allowProfToAdd,
                editionId,
              } = d
              let newStartDate = new Date(startDate)
              let newStartDateString = newStartDate.toLocaleDateString(util.GetCulture(), {
                weekday: 'short',
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              })
              return {
                startDate,
                dateString: newStartDateString,
                name,
                locationCity,
                educationInstituteName: course && course.educationInstitute && course.educationInstitute.name,
                locationCountryCode: locationCountry && locationCountry.code,
                courseId: course && course.id,
                isRemoteAttendance,
                agendaSubjectId: agendaSubject && agendaSubject.id,
                courseStatus,
                rating: course && course.rating,
                extraColumn,
                allowProfToAdd,
                editionId,
              }
            })
            let totalCountWithoutDate =
              data.data.courseCatalogueItemsWithoutDate.totalCount !== null
                ? data.data.courseCatalogueItemsWithoutDate.totalCount
                : 0
            let pageInfoWithoutDate = data.data.courseCatalogueItemsWithoutDate.pageInfo
            var items2 = data.data.courseCatalogueItemsWithoutDate.items.map((d) => {
              var { name, course, courseStatus, extraColumn, allowProfToAdd } = d
              return {
                startDate: null,
                name,
                locationCity: null,
                educationInstituteName: course && course.educationInstitute && course.educationInstitute.name,
                locationCountryCode: null,
                courseId: course && course.id,
                isRemoteAttendance: null,
                courseStatus,
                rating: course && course.rating,
                extraColumn,
                allowProfToAdd,
              }
            })
            let items = items1.concat(items2)
            if (state.loadingNewItems === true) {
              commit('addXVtableItems', items)
              commit('setPageInfo', { pageInfoWithDate, pageInfoWithoutDate })
              commit('setTotalCount', { totalCountWithDate, totalCountWithoutDate })
            } else {
              commit('setXVtableColumnsettings')
              commit('setXVtablesetting')
              commit('setXVtabledata', items)
              commit('setPageInfo', { pageInfoWithDate, pageInfoWithoutDate })
              commit('setTotalCount', { totalCountWithDate, totalCountWithoutDate })
            }
          } else if (data.error.graphQLErrors[0].extensions.message === 'User not authenticated.') {
            commit('setRedirectCatMelding')
          }
          commit('setTableLoading', false)
        })
    } else {
      dispatch('filterTableData')
    }
  },
  filterClick: async ({ dispatch, commit }) => {
    commit('resetSkipTableItems') // resetten skip naar 0
    dispatch('filterTableData')
  },
  filterTableData: async ({ dispatch, commit }) => {
    commit('setTableLoading', true)
    if (!state.loadingNewItems) {
      commit('setXVtabledata', [])
    }
    // window.scrollTo(0,0) werkt niet als filter lager op de pagina gebruikt.
    const localStore = locStore.namespace('filterInputData')

    let and = []
    if (state.filterinputdata.tbxStartDate !== null) {
      if (state.filterinputdata.tbxStartDate.toDateString() !== new Date().toDateString()) {
        state.hasFilter = true
      }
    }
    if (state.filterinputdata.cbCourseType === 1) {
      state.hasFilter = true
      and.push({
        course: {
          and: [
            {
              courseType: { neq: 2 },
            },
            { courseType: { neq: 3 } },
          ],
        },
      })
    } else if (state.filterinputdata.cbCourseType === 2 || state.filterinputdata.cbCourseType === 3) {
      state.hasFilter = true
      and.push({
        course: {
          courseType: { eq: state.filterinputdata.cbCourseType },
        },
      })
    }
    if (state.filterinputdata.selectedCompetence !== '' && state.filterinputdata.selectedCompetencePercentage === 0) {
      state.hasFilter = true
      and.push({
        course: {
          competences: {
            some: {
              id: {
                eq: parseInt(state.filterinputdata.selectedCompetence, 10),
              },
            },
          },
        },
      })
    }
    if (state.filterinputdata.selectedCompetence !== '' && state.filterinputdata.selectedCompetencePercentage !== 0) {
      // {"course": {"competences": {"some": {"and": [{"id": {"eq": eq: 6}}, {"percentage": {"gte": gte: 20}}]}}}}
      state.hasFilter = true
      and.push({
        course: {
          competences: {
            some: {
              and: [
                { id: { eq: parseInt(state.filterinputdata.selectedCompetence, 10) } },
                { percentage: { gte: state.filterinputdata.selectedCompetencePercentage } },
              ],
            },
          },
        },
      })
    }
    if (state.filterinputdata.selectedCategory !== '') {
      state.hasFilter = true
      and.push({
        course: {
          categories: {
            some: {
              id: {
                eq: parseInt(state.filterinputdata.selectedCategory, 10),
              },
            },
          },
        },
      })
    }
    if (state.filterinputdata.cbSubSubCourseTree !== 0 || state.filterinputdata.cbSubSubCourseTreeDropdown !== '') {
      state.hasFilter = true
      var coursetreefilter
      if (state.filterinputdata.cbSubSubCourseTreeDropdown !== '') {
        coursetreefilter = Number(state.filterinputdata.cbSubSubCourseTreeDropdown)
      } else {
        coursetreefilter = state.filterinputdata.cbSubSubCourseTree
      }
      // {"course": {"courseTree": { "some": {"subSubLevelId": {"eq": 902}}}}}
      and.push({
        course: {
          courseTree: {
            some: {
              subSubLevelId: {
                eq: coursetreefilter,
              },
            },
          },
        },
      })
    }
    if (state.filterinputdata.tbxCourseNameId !== '') {
      state.hasFilter = true
      let or = []

      if (!isNaN(state.filterinputdata.tbxCourseNameId)) {
        let courseIdNumber = parseInt(state.filterinputdata.tbxCourseNameId, 10)
        or.push({
          course: { id: { eq: courseIdNumber } },
        })
      }
      or.push({
        name: {
          contains: state.filterinputdata.tbxCourseNameId,
        },
      })

      and.push({ or: or })
    }
    if (state.filterinputdata.tbxInstitute !== '') {
      state.hasFilter = true
      and.push({
        course: {
          educationInstitute: {
            name: {
              contains: state.filterinputdata.tbxInstitute,
            },
          },
        },
      })
    }
    if (state.filterinputdata.cbInstellingsAccr === true) {
      state.hasFilter = true
      and.push({
        course: {
          isAccreditedByEducationInstitute: { eq: true },
        },
      })
    }
    let skipWithout = false // withoutdate data ophalen wordt overgeslagen, omdat without geen lokatie filter heeft.
    if (state.filterinputdata.filterLocation) {
      let lt = 0
      if (state.filterinputdata.filterLocationLong > 0 || state.filterinputdata.filterLocationLat > 0) {
        lt = state.filterinputdata.locatieRange * 1000
      }
      skipWithout = true
      state.hasFilter = true
      var filterLocation = {
        locationCoordinates: {
          distance: {
            geometry: {
              type: 'Point',
              coordinates: [state.filterinputdata.filterLocationLong, state.filterinputdata.filterLocationLat],
              crs: 4326,
            },
            lt: lt,
          },
        },
      }
    }
    if (state.filterinputdata.categoryPoints > 0) {
      // "course": { "categories": { "some": { "points": { "gte": 20.9 } } } }
      state.hasFilter = true
      and.push({
        course: {
          categories: {
            some: {
              points: {
                gte: state.filterinputdata.categoryPoints,
              },
            },
          },
        },
      })
    }
    if (state.filterinputdata.selectedCourseRating > 1) {
      // {"course": {"rating": {"courseRatingAverage": {"eq": 0}}}}
      state.hasFilter = true
      and.push({
        course: {
          rating: {
            courseRatingAverage: {
              gte: state.filterinputdata.selectedCourseRating * 20,
            },
          },
        },
      })
    }
    if (state.filterinputdata.selectedEducationRating > 1) {
      // {"course": {"rating": {"educationRatingAverage": {"eq": 0}}}}
      state.hasFilter = true
      and.push({
        course: {
          rating: {
            educationRatingAverage: {
              gte: state.filterinputdata.selectedEducationRating * 20,
            },
          },
        },
      })
    }
    if (state.filterinputdata.selectedLanguage) {
      // {"course": {"languageSets": {"some": {"id": {"eq": 0}}}}}
      state.hasFilter = true
      and.push({
        course: {
          languageSets: {
            some: {
              id: {
                eq: parseInt(state.filterinputdata.selectedLanguage, 10),
              },
            },
          },
        },
      })
    }
    let clustersToAddToQuery = {}
    let clustersToAddToQueryArr = []

    // add checked cluster(head) profgroup to array clustersToAddToQueryArr
    state.clusters.map((cluster) => {

      // PE-29999 Agenda cluster filter werkt niet icm > 2 clusters
      // Sander 30-08-2023 addition #1 eq null to the array --> null means the profgroup self
      clustersToAddToQueryArr.push({
        requestedByClusterId: {
          eq: null,
        },
      })

      if (state.filterinputdata.cbclusters.includes(cluster.id)) {
        clustersToAddToQueryArr.push({
          requestedByClusterId: {
            eq: cluster.id,
          },
        })
      } 

      // PE-29999 Agenda cluster filter werkt niet icm > 2 clusters
      // Sander 30-08-2023 addition #2: add complete cluster filter (or! not an and)
      clustersToAddToQuery = {
        course: {
          or: clustersToAddToQueryArr,
        },
      }
      and.push(clustersToAddToQuery)

    })
    
    /*

    // code below commented by Sander 30-8-2023 and replaced by additions addition #1 and addition #2 above

    if (state.filterinputdata.cbclusters.length === 1) {
      console.log('Sander IF === 1: eq NULL')
      clustersToAddToQueryArr.push({
        requestedByClusterId: {
          eq: null,
        },
      })
      clustersToAddToQuery = {
        course: {
          or: clustersToAddToQueryArr,
        },
      }
      and.push(clustersToAddToQuery)
    } else if (state.filterinputdata.cbclusters.length === state.clusters.length) {
      // both filters means all tickets, so no need to add filters...
    } else {
      console.log('Sander ELSE === 1: eq NULL')
      clustersToAddToQueryArr.push({
        requestedByClusterId: {
          eq: null,
        },
      })      
      clustersToAddToQuery = {
        course: {
          or: clustersToAddToQueryArr,
        },
      }
      and.push(clustersToAddToQuery)
    }

    console.log(clustersToAddToQuery)
    */

    let andwith = [...and]
    let andwithout = [...and]
    if (state.filterinputdata.filterLocation) {
      andwith.push(filterLocation)
    }
    if (!state.hasFilter) {
      dispatch('getTableData')
    } else {
      if (!state.filterinputdata.tbxStartDate) {
        state.filterinputdata.tbxStartDate = new Date()
      }
      const opties = {
        professionGroupId: state.profgroupid,
        language: util.GetCulture().split('-')[0],
        date: state.filterinputdata.tbxStartDate,
        skip: state.tableSkip,
        take: 49,
        takeWithout: 49,
        whereWith: null,
        whereWithout: null,
        skipWithout: skipWithout,
      }
      if (andwithout.length) {
        opties.whereWithout = {
          and: andwithout,
        }
      }

      if (andwith.length) {
        opties.whereWith = {
          and: andwith,
        }
      }
      const query = `query courseCatalogue(
      $professionGroupId: Int!
      $language: String!
      $date: DateTime
      $skip: Int
      $take: Int
      $takeWithout: Int
      $whereWith: CourseCatalogueItemWithDateFilterInput
      $whereWithout: CourseCatalogueItemWithoutDateFilterInput
      $skipWithout: Boolean!
    ) {
      courseCatalogueItemsWithDate(
        professionGroupId: $professionGroupId
        language: $language
        dateFrom: $date
        skip: $skip
        take: $take
        where: $whereWith
        order: {
          startDate: ASC,
          name: ASC
        }
      ) {
        totalCount
        pageInfo {
          hasNextPage
        }
        items {
          editionId
          allowProfToAdd
          isRemoteAttendance
          agendaSubject {
            id
          }
          startDate
          name
          locationCity
          courseStatus

          locationCountry {
            code
          }
          course {
            id
            courseType
            educationInstitute {
              name
            }
            rating {
              courseRatingAverage
              courseRatingCount
              educationRatingAverage
              educationRatingCount
            }
          }
          extraColumn
        }
      }
      courseCatalogueItemsWithoutDate(
        professionGroupId: $professionGroupId
        language: $language
        date: $date
        skip: $skip
        take: $takeWithout
        where: $whereWithout
        order: { name: ASC }
      ) @skip(if: $skipWithout)
      {
        totalCount
        pageInfo {
          hasNextPage
        }
        items {
          allowProfToAdd
          name
          courseStatus
          course {
            id
            courseType
            educationInstitute {
              name
            }
            rating {
              courseRatingAverage
              courseRatingCount
              educationRatingAverage
              educationRatingCount
            }
          }
          extraColumn
        }
      }
    }`
      const client = await util.createUrqlClient('/public/graphql/')
      client
        .query(query, opties)
        .toPromise()
        .then((data) => {
          let totalCountWithDate =
            data.data.courseCatalogueItemsWithDate.totalCount !== null
              ? data.data.courseCatalogueItemsWithDate.totalCount
              : 0
          let pageInfoWithDate = data.data.courseCatalogueItemsWithDate.pageInfo
          var itemsWith = data.data.courseCatalogueItemsWithDate.items.map((d) => {
            var {
              startDate,
              name,
              locationCity,
              course,
              locationCountry,
              isRemoteAttendance,
              agendaSubject,
              courseStatus,
              extraColumn,
              allowProfToAdd,
              editionId,
            } = d
            let newStartDate = new Date(startDate)
            let newStartDateString = newStartDate.toLocaleDateString(util.GetCulture(), {
              weekday: 'short',
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            })
            return {
              startDate,
              dateString: newStartDateString,
              name,
              locationCity,
              educationInstituteName: course && course.educationInstitute && course.educationInstitute.name,
              locationCountryCode: locationCountry && locationCountry.code,
              courseId: course && course.id,
              isRemoteAttendance,
              agendaSubjectId: agendaSubject && agendaSubject.id,
              courseStatus,
              rating: course && course.rating,
              extraColumn,
              allowProfToAdd,
              editionId,
            }
          })
          let totalCountWithoutDate = 0
          let pageInfoWithoutDate = {}
          var itemsWithout = {}
          let items = {}
          if (data.data.courseCatalogueItemsWithoutDate !== undefined) {
            totalCountWithoutDate =
              data.data.courseCatalogueItemsWithoutDate.totalCount !== null
                ? data.data.courseCatalogueItemsWithoutDate.totalCount
                : 0
            pageInfoWithoutDate = data.data.courseCatalogueItemsWithoutDate.pageInfo
            itemsWithout = data.data.courseCatalogueItemsWithoutDate.items.map((d) => {
              var { name, course, courseStatus, extraColumn, allowProfToAdd } = d
              return {
                startDate: null,
                dateString: '',
                name,
                locationCity: null,
                educationInstituteName: course && course.educationInstitute && course.educationInstitute.name,
                locationCountryCode: null,
                courseId: course && course.id,
                isRemoteAttendance: null,
                courseStatus,
                rating: course && course.rating,
                extraColumn,
                allowProfToAdd,
              }
            })
            items = itemsWith.concat(itemsWithout)
          } else {
            items = itemsWith
          }
          if (state.loadingNewItems === true) {
            commit('addXVtableItems', items)
            commit('setPageInfo', { pageInfoWithDate, pageInfoWithoutDate })
            commit('setTotalCount', { totalCountWithDate, totalCountWithoutDate })
          } else {
            if (localStore.local.get(state.profgroupid)) {
              commit('setXVtableColumnsettings')
            }
            commit('setXVtabledata', items)
            commit('setPageInfo', { pageInfoWithDate, pageInfoWithoutDate })
            commit('setTotalCount', { totalCountWithDate, totalCountWithoutDate })
          }
          commit('setTableLoading', false)
        })
    }
    localStore.local.set(state.profgroupid, state.filterinputdata)
  },
  getLblReset: async ({ state, commit, dispatch }) => {
    commit('setTableLoading', true)
    commit('setLblReset')
    commit('setXVtabledata', [])
    const localStore = locStore.namespace('filterInputData')
    localStore.local.remove(state.profgroupid)
    dispatch('getTableData')
  },
  getNextTableData: async ({ state, commit, dispatch }) => {
    commit('setTableLoading', true)
    if (!state.loadingNewItems && state.pageInfo.hasNextPage) {
      state.loadingNewItems = true
      commit('setSkipTableItems')

      if (state.hasFilter) {
        dispatch('filterTableData')
      } else {
        dispatch('getTableData')
      }
    }
    if (!state.pageInfo.hasNextPage) {
      commit('setTableLoading', false)
    }
  },
  getCourseDetail: async ({ state, commit }, props) => {
    state.loadingNewItems = true

    const query = `query GetCourse($professionGroupId: Int!, $courseId: Int!, $language: String) {
      course(
        professionGroupId: $professionGroupId
        courseId: $courseId
        language: $language
      ) {
        id
        name
        description
        categories {
          id
          name
          points
        }
        competences {
          id
          name
          percentage
          color
        }
      }
    }`
    const client = await util.createUrqlClient('/public/graphql/')
    const opties = {
      professionGroupId: state.profgroupid,
      courseId: props.courseId,
      language: util.GetCulture().split('-')[0],
    }
    client
      .query(query, opties)
      .toPromise()
      .then((data) => {
        let tablerowindex = props.rowIndex
        let courseData = data.data.course
        commit('setCourseDetail', { tablerowindex, courseData })
      })

    commit('stopLoading', null, { root: true })
    setTimeout(() => {
      state.loadingNewItems = false
    }, 2000)
  },
  getLocation: async ({ state, commit, dispatch }) => {
    commit('setFilterLocation')
    if (state.filterinputdata.filterLocation === false) {
      dispatch('filterTableData')
    } else {
      commit('resetSkipTableItems') // resetten skip naar 0
      var url =
        'https://maps.googleapis.com/maps/api/geocode/json?address=' +
        escape(state.filterinputdata.tbxLocatie) +
        '&sensor=false&key=AIzaSyCeVrN4sdMbrYt_HKLLAbiYSm-vrASmIPw'
      axios.get(url, { withCredentials: false }).then((response) => {
        // JSON responses are automatically parsed.
        let location
        if (response.data.results.length !== 0) {
          location = response.data.results[0].geometry.location
          // .geometry.location
          commit('setLocationLongLat', location)
          dispatch('filterTableData')
        } else {
          location = { lat: 0, lng: 0 }
          commit('setLocationLongLat', location)
          dispatch('filterTableData')
        }
      })
    }
  },
  getStickyHeight: async ({ state, commit, dispatch }) => {
    if (
      (state.lblMaatwerkBeschrijving !== '' || state.lblMaatwerkBeschrijving === null) &&
      document.getElementById('lblBeschrijving') !== null &&
      document.getElementById('tableinfo') !== null
    ) {
      commit('setStickyHeight')
    } else {
      setTimeout(function () {
        dispatch('getStickyHeight')
      }, 1000)
    }
  },
  getParametersFromUrl: async ({ commit }) => {
    commit('setStateFromRouteParameters')
  },
}

// mutations
const mutations = {
  ...setXVtableMutations('agendaTable'),
  setfilterinputdata(state, filterinputdata) {
    state.filterinputdata = {
      ...state.filterinputdata,
      ...filterinputdata,
    }
  },
  setStateFromRouteParameters(state) {
    const localStore = locStore.namespace('filterInputData')
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    let typeId = urlParams.get('typeId')
    const subsubId = urlParams.get('subsubId')
    const eduName = urlParams.get('eduName')
    if (typeId || subsubId || eduName) {
      localStore.local.remove(state.profgroupid)
      if (typeId) {
        state.hasFilter = true
        if (typeId === 4) {
          typeId = 1 // Apparently cbCoursetype id 4 doesn't exist, and has to be set to 1
        }
        state.filterinputdata.cbCourseType = Number(urlParams.get('typeId'))
      }
      if (subsubId) {
        state.hasFilter = true
        // state.filterinputdata.cbSubSubCourseTree = subsubId
        state.filterinputdata.cbSubSubCourseTreeDropdown = subsubId
      }
      if (eduName) {
        state.hasFilter = true
        state.filterinputdata.tbxInstitute = eduName
      }
      urlParams.delete(typeId, subsubId, eduName)
      let path = window.location.href.split('?')[0]
      window.history.pushState({}, document.title, path) // Remove search query from url so the localStore doesn't get wiped on refresh
    }
  },
  setRedirectCatMelding() {
    window.location = '/public/CatMelding.aspx'
  },
  setStateFilterInputDataFromLocalStorage(state) {
    const localStore = locStore.namespace('filterInputData')
    const localStorageFilterInputData = localStore.local.get(state.profgroupid)
    if (localStorageFilterInputData) {
      const {
        categoryPoints,
        cbCourseType,
        locatieRange,
        filterLocation,
        filterLocationLat,
        filterLocationLong,
        cbInstellingsAccr,
        cbclusters,
        cbSubSubCourseTreeDropdown,
        cbSubSubCourseTree,
        selectedCategory,
        selectedCompetence,
        selectedCourseRating,
        selectedEducationRating,
        selectedLanguage,
        tbxCourseNameId,
        tbxInstitute,
        tbxLocatie,
        tbxStartDate,
        selectedCompetencePercentage,
      } = localStorageFilterInputData
      const localStoragefilterinputdata = {
        categoryPoints,
        cbCourseType,
        cbInstellingsAccr,
        cbSubSubCourseTree,
        cbSubSubCourseTreeDropdown,
        cbclusters,
        locatieRange,
        filterLocation,
        filterLocationLat,
        filterLocationLong,
        selectedCompetence,
        selectedCategory,
        selectedCourseRating,
        selectedEducationRating,
        tbxCourseNameId,
        tbxInstitute,
        selectedLanguage,
        tbxLocatie,
        tbxStartDate: new Date(tbxStartDate),
        selectedCompetencePercentage,
      }
      if (state.filterinputdata !== localStoragefilterinputdata) {
        state.filterinputdata = localStoragefilterinputdata
        state.hasFilter = true
      }
    }
  },
  setActiveProfGr(state) {
    state.activeProfGr = util.UgetCookie('pe_activeProfGroup')
  },
  setActiveProfOrgid(state) {
    state.activeProfOrgId = util.UgetCookie('pe_activeProfOrg')
  },
  setXVtabledata: (state, data) => {
    if (data !== undefined) {
      state.agendaTable.tabledata = data
    }
    // alle detailrijen dichtgeklapt
    let extraColumnVisible = false
    state.agendaTable.tabledata.forEach((row, index) => {
      Vue.set(row, 'tableRowState', {
        rowVisible: false,
        editModus: false,
        storeTableindex: index,
        courseDetails: {},
      })
      if (row.extraColumn !== null) {
        extraColumnVisible = true
        if (row.extraColumn.includes('class="button"')) {
          row.extraColumn = row.extraColumn.replace('class="button"', 'class="btn btn-primary btn-xs"')
        }
      }
    })
    if (!state.agendaTable.tablecolumnsetting.some((x) => x.name === 'tableRowState')) {
      state.agendaTable.tablecolumnsetting.push({
        Columnname: 'tableRowState',
        helpTextID: null,
        name: 'tableRowState',
        headerTextID: null,
        sequence: state.agendaTable.tablecolumnsetting.length + 2,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        Type: null,
        visible: 0,
        visibleMD: null,
        visibleSM: null,
        visibleXS: null,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'agenda',
        procedure: '',
      })
    }
    if (extraColumnVisible === true && !state.agendaTable.tablecolumnsetting.some((x) => x.name === 'extraColumn')) {
      state.agendaTable.tablecolumnsetting.push({
        Columnname: ' ',
        helpTextID: null,
        name: 'extraColumn',
        headerTextID: null,
        sequence: state.agendaTable.tablecolumnsetting.length + 1,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        Type: 'string',
        visible: 1,
        visibleMD: 1,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: '70px',
        widthSM: null,
        widthXS: null,
        tableName: 'agenda',
        procedure: 'agendaTable',
      })
    }
  },
  setFilterSettings(state, data) {
    state.filterCourseOtherProfGroup = data.courseCatalogueSettings.filterCourseOtherProfGroup
    state.filtersettings.hasAccreditation = data.courseCatalogueSettings.hasAccreditation
    state.filtersettings.hasRatings = data.courseCatalogueSettings.hasRatings
    state.hideCoursePoints = data.courseCatalogueSettings.hideCoursePoints
    state.filtersettings.maxPoints = data.courseCatalogueSettings.maximumPoints
    state.filtersettings.maxPointsMarks = [0, data.courseCatalogueSettings.maximumPoints]
    state.filtersettings.courseTreeHeader = data.courseCatalogueSettings.profgrouplevelheaderName
    state.profgroupName = data.courseCatalogueSettings.profGroupName
    state.lblMaatwerkBeschrijving = data.courseCatalogueSettings.profgroupcoursecatalogueName

    state.clusters = data.clustersLookup

    if (state.filterCourseOtherProfGroup === 1 || state.filterCourseOtherProfGroup === 2) {
      state.hasFilter = true
      state.clusters.map((cluster) => {
        state.filterinputdata.cbclusters.push(cluster.id)
      })
    }

    // type 1 of 4 is klassikaal, 2 is online, 3 is groepen. text-id's overnemen uit aspx pagina.
    if (data.courseTypes.some((t) => t.id === 1 || t.id === 4)) {
      const klassikaal = { value: 1, labelText: store.state.translation[5136] }
      state.filterdata.courseTypes.push(klassikaal)
    }
    if (data.courseTypes.some((t) => t.id === 2)) {
      const online = { value: 2, labelText: store.state.translation[10631] }
      state.filterdata.courseTypes.push(online)
    }
    if (data.courseTypes.some((t) => t.id === 3)) {
      const groepen = { value: 3, labelText: store.state.translation[10632] }
      state.filterdata.courseTypes.push(groepen)
    }
    if (state.filterdata.courseTypes.length === 1) {
      // If there's only 1 type, set that id as the active value
      state.filterinputdata.cbCourseType = state.filterdata.courseTypes[0].value
      state.hasFilter = true
    }
    state.filterSettingsLoaded = true

  },
  setFilterData(state, data) {
    state.filterinputdata.tbxStartDate = new Date()
    state.categories = data.categoriesLookup
    state.competences = data.competencesLookup
    state.languages = data.languageSetsLookup

    state.filterinputdata.selectedCourseRating = 1
    state.filterinputdata.selectedEducationRating = 1

    state.filtersettings.locationmarks = [0, 5, 10, 15, 20, 25, 40, 50, 100, 250, 500, 1000, 5000, 20000]
    state.filterinputdata.locatieRange = 20000
    state.filterLoaded = true
  },
  setFilterCourseTrees(state, courseTrees) {
    // variable toevoegen aan levens van coursetree voor open en dicht klappen van CourseTree.
    courseTrees.forEach((main) => {
      main.mainRowToggle = false
      // afvangen of coursetree header zichtbaar is
      if (courseTrees.length === 1 && main.subLevels.length === 1 && state.filterdata.courseTree.length === 0) {
        state.filtersettings.showCourseTreeHeader = false
      } else {
        state.filtersettings.showCourseTreeHeader = true
      }
      main.subLevels.forEach((sub1) => {
        sub1.subRowToggle = false
        // als er geen main en sub is, worden subsub items in een dropdown gezet.
        state.filtersettings.courseTreeSubSubItems = sub1.subSubLevels
          .map((subsub) => ({
            value: subsub.id,
            labelText: subsub.name,
          }))
          .sort(dynamicSort('labelText'))
        sub1.subSubLevels.forEach((sub2) => {
          sub2.subSubRowToggle = false
        })
      })
    })
    state.filterdata.courseTree.push(courseTrees)
    state.filterdata.courseTree[0] && state.filterdata.courseTree[0].length === 1
      ? (state.filtersettings.courseTreeDropdown = true)
      : (state.filtersettings.courseTreeDropdown = false)
  },
  setCourseTreeHeaderName(state, headerName) {
    if (state.filtersettings.courseTreeHeader === '' || state.filtersettings.courseTreeHeader === null) {
      state.filtersettings.courseTreeHeader = headerName
    }
  },
  setLocationLongLat(state, location) {
    state.filterinputdata.filterLocationLong = location.lng
    state.filterinputdata.filterLocationLat = location.lat
  },
  setLocatieOnbekend(state) {
    state.filterinputdata.filterLocationLong = 0
    state.filterinputdata.filterLocationLat = 0
  },
  setFilterLocation(state) {
    if (state.filterinputdata.tbxLocatie === '') {
      state.filterinputdata.filterLocation = false
    } else {
      state.filterinputdata.filterLocation = true
    }
  },
  addXVtableItems(state, data) {
    state.agendaTable.tabledata = [...state.agendaTable.tabledata, ...data]
    state.agendaTable.tabledata.forEach((row, index) => {
      // maak voor alle nieuwe rows een state object aan
      if (!row.tableRowState) {
        Vue.set(row, 'tableRowState', {
          rowVisible: false,
          editModus: false,
          storeTableindex: index,
          courseDetails: {},
        })
      }
    })
    state.loadingNewItems = false
  },
  setTableLoading(state, bool) {
    state.tableLoader = bool
  },
  setprofgroupid(state, pid) {
    state.profgroupid = pid
  },
  setPageInfo(state, data) {
    if (data.pageInfoWithDate.hasNextPage === true || data.pageInfoWithoutDate.hasNextPage === true) {
      state.pageInfo.hasNextPage = true
    } else {
      state.pageInfo.hasNextPage = false
    }
  },
  setLanguageCookie(state, langId) {
    util.UsetCookie('urlparamLanguageId', langId)
  },
  setTotalCount(state, data) {
    state.totalCount = data.totalCountWithDate + data.totalCountWithoutDate
  },
  setSkipTableItems() {
    state.tableSkip = state.tableSkip + 49
  },
  resetSkipTableItems() {
    state.tableSkip = 0
  },
  setCourseTreeMainVisible(state) {
    state.filtersettings.courseTreeDropdown = !state.filtersettings.courseTreeDropdown
  },
  setCourseTreeSubVisible(state, id) {
    state.filterdata.courseTree.forEach((t) => {
      t.filter((s) => s.id === id).forEach((sub) => {
        sub.mainRowToggle = !sub.mainRowToggle
      })
    })
  },
  setCourseTreeSubSubVisible(state, id) {
    state.filterdata.courseTree.forEach((tree) => {
      tree.forEach((main) => {
        main.subLevels
          .filter((sub) => sub.id === id)
          .forEach((subsub) => {
            subsub.subRowToggle = !subsub.subRowToggle
          })
      })
    })
  },
  setStickyHeight(state) {
    if (state.lblMaatwerkBeschrijving !== '' && state.lblMaatwerkBeschrijving !== null) {
      state.stickyHeight =
        document.getElementById('lblBeschrijving').clientHeight + document.getElementById('tableinfo').clientHeight + 30
    }
  },
  toggleFilter(state) {
    state.loadMobileFilter = !state.loadMobileFilter
  },
  langChanged(state, bool) {
    // state.langIsChanged = bool
  },
  setLblReset(state) {
    console.log(state.filterdata.courseTree)
    state.hasFilter = false
    state.tableSkip = 0
    state.filterdata.courseTree[0] && state.filterdata.courseTree[0].length === 1
      ? (state.filtersettings.courseTreeDropdown = true)
      : (state.filtersettings.courseTreeDropdown = false)
    state.filterinputdata = {
      tbxStartDate: new Date(),
      selectedCompetence: '',
      selectedCategory: '',
      tbxCourseNameId: '',
      tbxInstitute: '',
      tbxLocatie: '',
      cbSubSubCourseTree: 0,
      cbSubSubCourseTreeDropdown: '',
      categoryPoints: 0,
      cbInstellingsAccr: false,
      locatieRange: 20000,
      cbCourseType: state.filterdata.courseTypes.length === 1 ? state.filterdata.courseTypes[0].value : 1,
      cbclusters:
        state.filterCourseOtherProfGroup === 1 || state.filterCourseOtherProfGroup === 2
          ? state.filterinputdata.cbclusters
          : [],
      selectedLanguage: '',
      selectedCourseRating: 1,
      selectedEducationRating: 1,
      filterLocation: false,
      filterLocationLong: 0,
      filterLocationLat: 0,
      selectedCompetencePercentage: 0,
    }
    state.filterdata.courseTree.forEach((t) => {
      t.forEach((sub) => {
        sub.mainRowToggle = false
      })
    })
    state.filterdata.courseTree.forEach((tree) => {
      tree.forEach((main) => {
        main.subLevels.forEach((subsub) => {
          subsub.subRowToggle = false
        })
      })
    })
    if (state.filterdata.courseTypes.length > 0) {
      state.hasFilter = true
    }
  },
  setCourseDetail(state, { tablerowindex, courseData }) {
    let course = state.agendaTable.tabledata.find((course) => course.tableRowState.storeTableindex === tablerowindex)
    Vue.set(course.tableRowState, 'courseDetails', courseData)
  },
  setXVtablesetting(state) {
    state.agendaTable.tablesetting = {
      AlwaysShowDetail: null,
      tableName: 'agenda',
      paging: 1,
      pagingSize: 49,
      procedure: 'agendaTable',
      sequence: 1,
      sortable: 0,
    }
  },
  setXVtableColumnsettings(state) {
    state.agendaTable.tablecolumnsetting = [
      {
        Columnname: '',
        helpTextID: null,
        name: 'openDetail',
        headerTextID: 0,
        sequence: 1,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        Type: 'string',
        visible: 1,
        visibleMD: 1,
        visibleSM: 1,
        visibleXS: 1,
        widthMD: '30px',
        widthSM: '30px',
        widthXS: '30px',
        tableName: 'agenda',
        procedure: 'agendaTable',
      },
      {
        Columnname: store.getters.translation(16718),
        helpTextID: null,
        name: 'startDate',
        headerTextID: null,
        sequence: 3,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        Type: 'date',
        visible: 1,
        visibleMD: 1,
        visibleSM: 1,
        visibleXS: 1,
        widthMD: '150px',
        widthSM: null,
        widthXS: null,
        tableName: 'agenda',
        procedure: 'agendaTable',
      },
      {
        Columnname: store.getters.translation(16719),
        helpTextID: null,
        name: 'name',
        headerTextID: null,
        sequence: 4,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        Type: 'string',
        visible: 1,
        visibleMD: 1,
        visibleSM: 1,
        visibleXS: 1,
        widthMD: '75%',
        widthSM: '100%',
        widthXS: '100%',
        tableName: 'agenda',
        procedure: 'agendaTable',
      },
      {
        Columnname: 'CourseId',
        helpTextID: null,
        name: 'courseId',
        headerTextID: null,
        sequence: 2,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        Type: 'number',
        visible: 0,
        visibleMD: 0,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'agenda',
        procedure: 'agendaTable',
      },
      {
        Columnname: store.getters.translation(16720),
        helpTextID: null,
        name: 'locationCity',
        headerTextID: null,
        sequence: 5,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        Type: 'string',
        visible: 1,
        visibleMD: 1,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: '200px',
        widthSM: null,
        widthXS: null,
        tableName: 'agenda',
        procedure: 'agendaTable',
      },
      {
        Columnname: store.getters.translation(16721),
        helpTextID: null,
        name: 'educationInstituteName',
        headerTextID: null,
        sequence: 6,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        Type: 'string',
        visible: 1,
        visibleMD: 1,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: '25%',
        widthSM: '25%',
        widthXS: null,
        tableName: 'agenda',
        procedure: 'agendaTable',
      },
      {
        Columnname: 'locationCountryCode',
        helpTextID: null,
        name: 'locationCountryCode',
        headerTextID: null,
        sequence: 7,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        Type: 'string',
        visible: 0,
        visibleMD: 0,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'agenda',
        procedure: 'agendaTable',
      },
      {
        Columnname: 'isRemoteAttendance',
        helpTextID: null,
        name: 'isRemoteAttendance',
        headerTextID: null,
        sequence: 8,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        Type: 'string',
        visible: 0,
        visibleMD: 0,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'agenda',
        procedure: 'agendaTable',
      },
      {
        Columnname: 'agendaSubjectId',
        helpTextID: null,
        name: 'agendaSubjectId',
        headerTextID: null,
        sequence: 8,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        Type: 'number',
        visible: 0,
        visibleMD: 0,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'agenda',
        procedure: 'agendaTable',
      },
      {
        Columnname: 'courseStatus',
        helpTextID: null,
        name: 'courseStatus',
        headerTextID: null,
        sequence: 9,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        Type: 'string',
        visible: 0,
        visibleMD: 0,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'agenda',
        procedure: 'agendaTable',
      },
      {
        Columnname: 'rating',
        helpTextID: null,
        name: 'rating',
        headerTextID: null,
        sequence: 10,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        Type: 'string',
        visible: 0,
        visibleMD: 0,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'agenda',
        procedure: 'agendaTable',
      },
      {
        Columnname: 'allowProfToAdd',
        helpTextID: null,
        name: 'allowProfToAdd',
        headerTextID: null,
        sequence: 11,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        Type: 'number',
        visible: 0,
        visibleMD: 0,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'agenda',
        procedure: 'agendaTable',
      },
      {
        Columnname: 'editionId',
        helpTextID: null,
        name: 'editionId',
        headerTextID: null,
        sequence: 12,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        Type: 'number',
        visible: 0,
        visibleMD: 0,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'agenda',
        procedure: 'agendaTable',
      },
      {
        Columnname: '',
        helpTextID: null,
        name: 'dateString',
        headerTextID: null,
        sequence: 13,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        Type: 'string',
        visible: 0,
        visibleMD: 0,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'agenda',
        procedure: 'agendaTable',
      },
    ]
  },
}

function dynamicSort(property) {
  var sortOrder = 1
  if (property[0] === '-') {
    sortOrder = -1
    property = property.substr(1)
  }
  return function (a, b) {
    var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0
    return result * sortOrder
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
